import apiCompetition from '@/api/competition'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getCompetitionsListStart: '[competition list] Get competitions start',
  getCompetitionsListSuccess: '[competition list] Get competitions success',
  getCompetitionsListFailure: '[competition list] Get competitions failure',
}

export const actionTypes = {
  getCompetitionsList: '[competition list] Get competition',
}

const mutations = {
  [mutationTypes.getCompetitionsListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getCompetitionsListSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitionsList](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getCompetitionsListStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionList(params)
        .then((response) => {
          context.commit(mutationTypes.getCompetitionsListSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getCompetitionsListFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
